import n from "./highrise1414.mjs";
import t from "./highrise1415.mjs";
function f(a, r) {
  return a != null && t(a, r, n);
}
export {
  f as default
};
